(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const buttons = root.querySelectorAll('[data-filter]');
    const cards = root.querySelectorAll('[data-category]');
    function filter(key) {
      let count = 0;
      cards.forEach(card => { card.hidden = key !== 'all' && card.dataset.category !== key; if (!card.hidden) count++; });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === key)));
      root.querySelector('.studio-count').textContent = `${count} ${count === 1 ? 'formula' : 'formulas'} to explore`;
    }
    buttons.forEach(button => button.addEventListener('click', () => filter(button.dataset.filter)));
    root.querySelectorAll('[data-category-link]').forEach(link => link.addEventListener('click', () => filter(link.dataset.categoryLink)));
    const mapping = {'wash-and-prep':'wash','protection':'protect','interior-and-glass':'interior','wheels-and-tires':'wheels','specialty':'specialty'};
    const handle = location.pathname.split('/').pop();
    if (mapping[handle]) filter(mapping[handle]);
  }
  document.querySelectorAll('.studio').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('.studio').forEach(init));
})();
